import React from 'react';
import { Field } from 'react-final-form';

import css from './FieldPlusMinusToggle.module.css';

export default function FieldPlusMinusToggle({ name, defaultValue = 'add' }) {
  return (
    <Field name={name}>
      {({ input }) => {
        const value = input.value === '' || input.value == null ? defaultValue : input.value;

        const toggle = () => {
          const newType = value === 'add' ? 'discount' : 'add';
          input.onChange(newType);
        };

        return (
          <button
            type="button"
            onClick={toggle}
            className={css.toggleButton}
            aria-pressed={value === 'add'}
          >
            {/* sliding background */}
            <div
              className={`${css.slider} ${value === 'add' ? css.sliderLeft : css.sliderRight}`}
            />

            {/* visible content */}
            <div className={css.inner}>
              <span className={`${css.symbol} ${value === 'add' ? css.activeText : ''}`}>+</span>
              <span className={`${css.symbol} ${value === 'discount' ? css.activeText : ''}`}>
                -
              </span>
            </div>
          </button>
        );
      }}
    </Field>
  );
}
